export default __webpack_public_path__ + "static/media/help.769ea841.png";